import type { ReactNode } from "react";

import { color } from "../tokens";

// Shared focus-visible treatment for interactive components.
export const focusRing =
  "focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface";

export function VisuallyHidden({ children }: { children: ReactNode }) {
  return (
    <span className="absolute size-px overflow-hidden whitespace-nowrap border-0 p-0 [clip:rect(0,0,0,0)]">
      {children}
    </span>
  );
}

// Brand highlight marker — a lime underline behind dark text (never a fill under
// white text). Use for headings/emphasis.
export function Highlight({ children }: { children: ReactNode }) {
  return (
    <span
      style={{
        backgroundImage: `linear-gradient(transparent 65%, ${color.highlight} 65%)`,
      }}
    >
      {children}
    </span>
  );
}
